import * as React from "react";

import "./button.scss";

export interface ButtonProps {
  buttonText: string;
  id?: string;
  type?: "button" | "submit" | "reset";
  layout?: "primary" | "secondary" | "transparent";
  disabled?: boolean;
  clickHandler?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  beforeTextChildren?: () => JSX.Element;
  afterTextChildren?: () => JSX.Element;
}

export const Button = (props: ButtonProps) => {
  return (
    <button
      type={props.type ?? "button"}
      disabled={props.disabled}
      id={props.id}
      className={`btn btn--${props.layout ?? "primary"}`}
      onClick={(event) => {
        if (props.clickHandler) {
          props.clickHandler(event);
        }
      }}
    >
      {props.beforeTextChildren && props.beforeTextChildren()}
      <span className="btn-text">{props.buttonText}</span>
      {props.afterTextChildren && props.afterTextChildren()}
    </button>
  );
};
